import { createStore, createActionsHook, type Action, createHook } from 'react-sweet-state';
import type { Command } from '@atlassian/jira-command-palette';

type State = {
	commands: Command[];
};
const initialState: State = {
	commands: [],
};

const addChildCommands =
	(commands: Command[]): Action<State> =>
	({ setState, getState }) => {
		const currentState = getState();
		const newCommands = currentState.commands.concat(commands);
		const newState: Partial<State> = { commands: newCommands };
		setState(newState);
	};

const removeChildCommands =
	(commands: Command[]): Action<State> =>
	({ setState, getState }) => {
		const newCommands = getState().commands.filter((command) => !commands.includes(command));
		setState({
			commands: newCommands,
		});
	};

// For testing
const reset =
	(): Action<State> =>
	({ setState }) => {
		setState(initialState);
	};

const actions = {
	addChildCommands,
	removeChildCommands,
	reset,
};
type Actions = typeof actions;
const store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'command-store',
});

export const useChildCommands = createHook(store);

export const useChildCommandActions = createActionsHook(store);
